import { SPECIAL_OFFER_STATUS } from '@/configs/constant'
import SpecialOfferApi from '@/api/special-offer-api'
import { getImageData } from '@/helpers'
import { get, pull } from 'lodash'

export const getDuplicateSpecialOfferDetail = async (id) => {
  const result = await SpecialOfferApi.detail(id)
  const specialOfferDetail = result.specialOfferDetail
  const newSpecialOfferData = {
    id: '',
    refCode: '',
    status: SPECIAL_OFFER_STATUS.DRAFT
  }
  const duplicatedData = Object.assign({}, specialOfferDetail, newSpecialOfferData)

  return duplicatedData
}

export const prepareDocumentData = (specialOfferDetail, selectedAgent) => {
  const hotelLogoElementId = 'sp-hotel-logo'
  const hotelLogoData = getImageData(hotelLogoElementId)
  const header = document.getElementById('doc-special-offer-header').innerHTML
  const detail = document.getElementById('doc-special-offer-detail').innerHTML

  const hotelSalePerson = get(specialOfferDetail, 'hotel.salePerson', {})
  const salePerson = _getSalePersonData(hotelSalePerson)
  const contact = _getContactPersonData(selectedAgent)

  const refCode = `${specialOfferDetail.refCode}/${selectedAgent.name}`
  const data = {
    hotelLogo: hotelLogoData,
    header: header,
    detail: detail,
    contact: contact,
    salePerson: salePerson,
    refCode: refCode
  }

  return data
}

function _getContactPersonData (selectedAgent) {
  const title = get(selectedAgent, 'contactPerson.title', '')
  const firstName = get(selectedAgent, 'contactPerson.firstName', '')
  const lastName = get(selectedAgent, 'contactPerson.lastName', '')
  const position = get(selectedAgent, 'contactPerson.position', '')

  const contactName = `${title} ${firstName} ${lastName}`
  const data = {
    name: contactName.trim(),
    position: position
  }

  return data
}
function _getSalePersonData (salePerson) {
  const title = get(salePerson, 'title', '')
  const firstName = get(salePerson, 'firstName', '')
  const lastName = get(salePerson, 'lastName', '')
  const position = get(salePerson, 'position', '')
  const salePersonName = `${title} ${firstName} ${lastName}`
  const signature = getImageData('sale-person-signature', true)

  const data = {
    name: salePersonName.trim(),
    position: position,
    signature: signature
  }

  return data
}

export const getTableDataSource = (sourceDataList, specialOfferDataList) => {
  const dataList = _prepareDataList(sourceDataList, specialOfferDataList)
  const deletedDataList = _getDeletedDataList(sourceDataList, specialOfferDataList)

  const tableDataList = [...dataList, ...deletedDataList]
  return tableDataList
}

function _prepareDataList (sourceDataList, specialOfferDataList) {
  const specialOfferTableDataList = sourceDataList.map((sourceData) => {
    const specialOfferData = specialOfferDataList.find(item => item.id === sourceData.id)

    if (specialOfferData !== undefined) {
      return specialOfferData
    }

    return sourceData
  })

  return specialOfferTableDataList
}

function _getDeletedDataList (sourceDataList, specialOfferDataList) {
  const deletedDataList = specialOfferDataList.map((specialOfferData) => {
    const sourceData = sourceDataList.find(item => item.id === specialOfferData.id)

    if (sourceData === undefined) {
      return specialOfferData
    }
  })

  const result = pull(deletedDataList, undefined)
  return result
}
